import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MEDIA } from "@/data/content";

const WORK = [
  { title: "Atlas Fitness", cat: "Web + Branding", span: "md:col-span-7", img: MEDIA.portfolio[0] },
  { title: "Verde Coffee", cat: "Social Campaign", span: "md:col-span-5", img: MEDIA.portfolio[1] },
  { title: "RiverCity Realty", cat: "SEO + Ads", span: "md:col-span-5", img: MEDIA.portfolio[2] },
  { title: "Capitol Wellness", cat: "Full Service", span: "md:col-span-7", img: MEDIA.portfolio[3] },
];

export const Portfolio = () => {
  return (
    <section id="work" data-testid="work-section" className="relative py-24 sm:py-32 border-t border-line">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="mono-label text-accent">[ Selected work ]</span>
            <h2 className="font-head font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-4 text-balance">
              Built for businesses<br />that mean business.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {WORK.map((w, i) => (
            <motion.div
              key={w.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 2) * 0.1 }}
              data-testid={`work-item-${i}`}
              className={`group relative overflow-hidden border border-line accent-glow ${w.span}`}
            >
              <div className="relative h-[340px] md:h-[420px] overflow-hidden">
                <img src={w.img} alt={w.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-7 flex items-end justify-between">
                <div>
                  <span className="mono-label text-accent">{w.cat}</span>
                  <h3 className="font-head font-bold text-2xl sm:text-3xl mt-1">{w.title}</h3>
                </div>
                <div className="w-11 h-11 flex items-center justify-center border border-white/20 group-hover:bg-accent group-hover:border-accent transition-colors">
                  <ArrowUpRight className="w-5 h-5 group-hover:text-ink" />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
